export const TAYLOR_TRIGGER_COUNT = 7;

export function advanceTapCount(count: number): { count: number; unlocked: boolean } {
  const nextCount = count + 1;
  if (nextCount >= TAYLOR_TRIGGER_COUNT) return { count: 0, unlocked: true };
  return { count: nextCount, unlocked: false };
}
